import {
	Button, Card, LinearProgress, Menu, MenuItem, Typography
} from '@material-ui/core';
import Chip from '@material-ui/core/Chip';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogTitle from '@material-ui/core/DialogTitle';
import IconButton from "@material-ui/core/IconButton";
import { makeStyles } from '@material-ui/core/styles';
import TextField from '@material-ui/core/TextField';
import Tooltip from '@material-ui/core/Tooltip';
import { DataGrid } from "@material-ui/data-grid";
import EditIcon from "@material-ui/icons/Edit";
import VpnKeyIcon from "@material-ui/icons/VpnKey";
import GroupAddIcon from '@material-ui/icons/GroupAdd';
import Autocomplete from '@material-ui/lab/Autocomplete';
import Form from "@rjsf/material-ui";
import React from 'react';
import { useActions, useValues } from 'kea';

import rolelogic from 'src/store/role';
import userlogic from 'src/store/user';
import grouplogic from 'src/store/group';
import profilelogic from 'src/store/profile';

import { formSchema, uiSchema } from './schema';

let modifiedFormSchema = JSON.parse(JSON.stringify(formSchema));

delete modifiedFormSchema.properties.email;
delete modifiedFormSchema.properties.repeat_email;
modifiedFormSchema.required.pop();
modifiedFormSchema.required.pop();

const useStyles = makeStyles((theme) => ({
	root: {
		width: "100%",
		height: '600px'
	},
	container: {
		maxHeight: '440'
	},
	chip: {
		margin: theme.spacing(0.5),
	}
}));

const withTooltip = (text) => (
	<Tooltip title={text}>
		<div style={{
			textOverflow: 'ellipsis',
			whiteSpace: 'nowrap',
			overflow: 'hidden'
		}}>
			{text}
		</div>
	</Tooltip >
)

const columns = [
	{
		field: 'enabled',
		headerName: 'Account Status',
		width: 200,
		renderCell: (params) => {
			return (
				<>
					{
						params.row.enabled ?
							<Chip color={'primary'} label={'Enabled'} style={{
								margin: '4px'
							}} />
							:
							<Chip color={'secondary'} label={'Disabled'} style={{
								margin: '4px'
							}} />
					}
					{/* <Chip label={params.row.status} style={{
						margin: '4px'
					}} /> */}
				</>
			);
		}
	},
	{
		field: 'full_name',
		headerName: 'Full name',
		width: 250,
		renderCell: (param) => withTooltip(param.row.full_name)
	},
	{
		field: 'job_title',
		headerName: 'Job Title',
		width: 150,
		renderCell: (param) => withTooltip(param.row.job_title)
	},
	{
		field: 'email',
		headerName: 'Email',
		width: 250,
		renderCell: (param) => withTooltip(param.row.email)
	},
	{
		field: 'groups',
		headerName: 'Groups',
		width: 150,
		renderCell: (params) => {
			return (
				<>
					{
						params.row.groups.length > 1 ?
							<Tooltip title={'Show All'}>
								<Chip variant='outlined' color='primary' label={'Show All'} style={{
									margin: '4px'
								}} onClick={(e) => params.row.showAll(e, params.row.groups)} />
							</Tooltip > :
							params.row.groups.map((group, index) => {
								if (index > 1) {
									return null;
								}
								return (
									<Chip label={group.name} style={{
										margin: '4px'
									}} />
								)
							})
					}
				</>
			);
		}
	},
	{
		field: 'roles',
		headerName: 'Permissions',
		width: 150,
		renderCell: (params) => {
			return (
				<>
					{
						params.row.roles.length > 1 ?
							<Tooltip title={'Show All'}>
								<Chip variant='outlined' color='primary' label={'Show All'} style={{
									margin: '4px'
								}} onClick={(e) => params.row.showAll(e, params.row.roles)} />
							</Tooltip > :
							params.row.roles.map((role, index) => {
								if (index > 1) {
									return null;
								}
								return (
									<Chip label={role} style={{
										margin: '4px'
									}} />
								)
							})
					}
				</>
			);
		}
	},
	{
		field: 'actions',
		align: 'right',
		headerName: 'Actions',
		width: 200,
		renderCell: (params) => {
			return (
				<>
					<Tooltip title='Password Reset'>
						<IconButton aria-label="delete" onClick={() => params.row.passwordResetDialog(params.row.edit)}>
							<VpnKeyIcon color="primary" />
						</IconButton>
					</Tooltip>
					<Tooltip title='Edit User'>
						<IconButton aria-label="delete" onClick={() => params.row.openEditDialog(params.row.edit)}>
							<EditIcon color="primary" />
						</IconButton>
					</Tooltip>
					<Tooltip title="Assign users to Group(s)">
						<IconButton aria-label="delete" onClick={() => params.row.openGroupDialog(params.row.edit)}>
							<GroupAddIcon />
						</IconButton>
					</Tooltip>
				</>
			);
		}
	},
];

const UserTable = () => {
	const classes = useStyles();

	const { profile } = useValues(profilelogic);

	const { roles } = useValues(rolelogic);

	const { users } = useValues(userlogic);
	const { update, updateGroup, sendPasswordEmail } = useActions(userlogic);

	const { groups } = useValues(grouplogic);


	const [data, setData] = React.useState([]);
	const [openEdit, setOpenEdit] = React.useState(false);
	const [editDialogData, setEditDialogData] = React.useState({});

	const [openGroup, setOpenGroup] = React.useState(false);
	const [groupDialogData, setGroupDialogData] = React.useState([]);
	const [groupDialogUser, setGroupDialogUser] = React.useState({});
	const [showAllAnchor, setShowAllAnchor] = React.useState(null);
	const [showAllData, setShowAllData] = React.useState(null);


	const [openPasswordRestDialog, setPasswordRestDialog] = React.useState(false);
	const [passwordRestDialogData, setPasswordRestDialogData] = React.useState({});


	const openEditDialog = (user) => {
		user.Enabled = !user.enabled;
		setEditDialogData(user);
		setOpenEdit(true);
	};

	const openGroupDialog = (user) => {
		setGroupDialogData(user.groups.map((g) => g._id) || []);
		setGroupDialogUser(user);
		setOpenGroup(true);
	};

	const handleGroupChange = (e, newValue) => {
		// console.log(newValue);
		let updateGroups = [...groupDialogData];
		updateGroups = newValue;
		setGroupDialogData(updateGroups);
	}

	modifiedFormSchema.properties.roles.items.anyOf = roles.map((role) => {
		return {
			enum: [role],
			title: role
		}
	})
	const closeEditDialog = () => setOpenEdit(false);
	const closeGroupDialog = () => setOpenGroup(false);

	const showAll = (e, items) => {
		setShowAllAnchor(e.currentTarget);
		setShowAllData(items.map(item => item.name || item));
	}

	const closeShowAll = () => {
		setShowAllAnchor(null);
	}

	const closePasswordResetDialog = () => setPasswordRestDialog(false);
	const handlePasswordResetDialog = (user) => {
		setPasswordRestDialogData(user);
		setPasswordRestDialog(true);
	}
	const handlePasswordResetDialogSubmit = () => {
		closePasswordResetDialog();
		sendPasswordEmail({ _id: passwordRestDialogData._id })
	}

	React.useEffect(() => {
		if (users.length > 0) {
			let newRows = users.filter((row) => {
				return row.email !== profile.email
			}).map((row) => {
				return {
					id: row._id,
					edit: row,
					enabled: row.enabled,
					status: row.status,
					full_name: `${row.title} ${row.first_name} ${row.last_name}`,
					job_title: row.job_title,
					email: row.email,
					groups: row.groups,
					roles: row.roles,
					openEditDialog: openEditDialog,
					openGroupDialog: openGroupDialog,
					passwordResetDialog: handlePasswordResetDialog,
					showAll: showAll,
				}
			});
			setData(newRows);
		}
	}, [users]);

	const onEditSubmit = async (value) => {
		value.formData.enabled = !value.formData.Enabled;
		delete value.formData.Enabled;
		update(value.formData);
		setOpenEdit(false);
	};


	const handleGroupSubmit = async () => {
		setOpenGroup(false);
		groupDialogUser.groups = groupDialogData;
		// console.log(selectedGeofence);
		// selectedGeofence.tracker = tracker;
		await updateGroup(groupDialogUser);
		setGroupDialogData([]);
		setGroupDialogUser({});
	}


	if (users.length === 0 || !groups) {
		return <LinearProgress />;
	}
	// console.log('groups', groups);
	// console.log('user.groups', groupDialogData);
	return (
		<Card
			className={classes.root}
		>
			<Dialog
				open={openPasswordRestDialog}
				onClose={closePasswordResetDialog}
				aria-labelledby="form-dialog-title"
			>
				<DialogTitle id="form-dialog-title">
					Password reset
				</DialogTitle>
				<DialogContent>
					<Typography>Are you sure you want to send a password reset email to {passwordRestDialogData.email}?</Typography>
				</DialogContent>
				<DialogActions>
					<Button onClick={closePasswordResetDialog} color="primary">
						Cancel
					</Button>
					<Button onClick={handlePasswordResetDialogSubmit} color="primary">
						Send
					</Button>
				</DialogActions>
			</Dialog>
			<Dialog
				open={openEdit}
				onClose={closeEditDialog}
				aria-labelledby="form-dialog-title"
			>
				<DialogTitle id="form-dialog-title">
					Edit a user
				</DialogTitle>
				<DialogContent>
					<Form
						schema={modifiedFormSchema}
						onSubmit={onEditSubmit}
						uiSchema={uiSchema}
						formData={editDialogData}
						showErrorList={false}
					>
						<div style={{ textAlign: 'center', paddingTop: '15px' }}>
							<Button type={'submit'} variant="contained" color="primary">
								Save
							</Button>
						</div>
					</Form>
				</DialogContent>
				<DialogActions>
				</DialogActions>
			</Dialog>
			<Menu
				id="long-menu"
				anchorEl={showAllAnchor}
				keepMounted
				open={Boolean(showAllAnchor)}
				onClose={closeShowAll}
				PaperProps={{
					style: {
						maxHeight: 48 * 4.5,
						width: '20ch',
					},
				}}
			>
				{showAllData ? showAllData.map((option) => (
					<MenuItem key={option}>
						{option}
					</MenuItem>
				)) : null}
			</Menu>
			<Dialog
				open={openGroup}
				onClose={closeGroupDialog}
				aria-labelledby="form-dialog-title"
			>
				<DialogTitle id="form-dialog-title">
					Assign Group(s) to this user
				</DialogTitle>
				<DialogContent>
					<Autocomplete
						multiple
						id="tags-standard"
						options={groups.map((g) => g._id)}
						getOptionLabel={(option) => {
							return groups.filter((g) => {
								return g._id === option;
							})[0].name
						}}
						size={'medium'}
						value={groupDialogData}
						filterSelectedOptions
						onChange={handleGroupChange}
						renderInput={(params) => (
							<TextField
								{...params}
								variant="standard"
								label="Select Groups"
							/>
						)}
					/>
				</DialogContent>
				<DialogActions>
					<Button onClick={closeGroupDialog} color="primary">
						Cancel
					</Button>
					<Button onClick={handleGroupSubmit} color="primary">
						Assign
					</Button>
				</DialogActions>
			</Dialog>
			<div style={{ height: '100%', width: '100%', background: 'white' }}>
				<DataGrid disableSelectionOnClick={true} rows={data} columns={columns} pageSize={10} />
			</div>
		</Card>
	);
};


export default UserTable;
